import createModalContext from 'app/components/utilities/createModalContext';

export const {
  ModalProvider:   CallSettingsModalProvider,
  GetModalControl: GetCallSettingsModalControl,
  IsModalOpen:     IsCallSettingsModalOpen,
} = createModalContext();
